/* global angular, TimelineMax, $ */
angular.module('ua5App')
    .directive('sideNav', ['TRANSITION', '$state', function(TRANSITION, $state) {
        return {
            restrict: 'A',
            templateUrl: 'components/side-nav/side-nav.html',
            scope: {
                sideNavText: '@',
                sideNavSref: '@',
                sideNavSide: '@'
            },
            link: function($scope, element, attrs) {
                var $$sideNav;
                var timeline;
                var initiated = false;
                $$sideNav = $(element).find('.side-nav');

                timeline = new TimelineMax({
                    paused: false
                });

                function showSideNav() {
                    timeline.clear();
                    timeline
                        .to($$sideNav, 0.80, {
                            opacity: 1,
                            display: 'block'
                        })
                    ;
                    timeline.play();
                }

                function hideSideNav() {
                    timeline.clear();
                    timeline
                        .to($$sideNav, 0.80, {
                            opacity: 0,
                            display: 'none'
                        })
                    ;
                    timeline.play();
                }

                // Hide / show depending on if the user is visiting the home
                // state or not.
                $scope.$on('$stateChangeStart', function(e, toState) {
                    if (toState.name !== 'home') {
                        hideSideNav();
                    }
                });

                $scope.$on('$stateChangeSuccess', function(e, toState) {
                    if (toState.name === 'home' && !initiated) {
                        showSideNav();
                        initiated = true;
                    } else {
                        hideSideNav();
                    }
                });

                // Reveal the sidebar after the posts have loaded if direct
                // linking into the home state.
                $scope.$on('returnedHome', function() {
                    if ($state.current.name === 'home') {
                        showSideNav();
                    }
                });
            }
        };
    }])
;
